import { ImagePosition } from "constants/notebooks/image-position";
import { ImageSize } from "constants/notebooks/image-size";
import { ImageBlockConfigurationRecord } from "models/view-models/block-configurations/image-block-configuration-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface ImageBlockConfigurationUpdatePathParams {
    configurationId: number;
}

export interface ImageBlockConfigurationUpdatePutParams {
    imageFileId: number | undefined;
    size: ImageSize;
    position: ImagePosition;
}

const resourceEndpoint: string = "blocks/configurations/image/:configurationId";
const resourceType = ImageBlockConfigurationRecord;

const ImageBlockConfigurationService = {
    useUpdate: ServiceHookFactory.useUpdateFromPutParams<
        ImageBlockConfigurationRecord,
        ImageBlockConfigurationUpdatePutParams,
        ImageBlockConfigurationUpdatePathParams
    >(resourceType, resourceEndpoint),
};

export default ImageBlockConfigurationService;
